import { TranslationsKeys } from 'store/interfaces';

export const formatDate = (date: string, language: TranslationsKeys) =>
  new Date(date).toLocaleDateString('DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
